import {Box} from '@tempo/core';
import type {HTMLChakraProps} from '@tempo/system';

export const IFrame = (props: HTMLChakraProps<'iframe'>) => (
	<Box as="iframe" loading="lazy" {...props} />
);
